var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { sendErrorToSentry } from './../../../../app/js/utils/web-helper';
import { BOOKLIBRARY } from '../../constant-data/constants';
export var bookLauncher = function (props) { return __awaiter(void 0, void 0, void 0, function () {
    var client_id, _a, _b, actionData, _c, payloadData, searchParams, feMus, path, options;
    var _d, _e, _f;
    return __generator(this, function (_g) {
        client_id = sessionStorage.getItem('client_id') || '';
        _a = props || {}, _b = _a.actionData, actionData = _b === void 0 ? {} : _b, _c = _a.payloadData, payloadData = _c === void 0 ? {} : _c;
        searchParams = new URLSearchParams();
        searchParams.append("user_id", "".concat(actionData === null || actionData === void 0 ? void 0 : actionData.user_id));
        searchParams.append("book_code", "".concat(actionData === null || actionData === void 0 ? void 0 : actionData.isbn));
        feMus = ((_d = window.trackerProperties) === null || _d === void 0 ? void 0 : _d.musAbTestSegment) === 'Variant'
            ? (_e = window.trackerProperties) === null || _e === void 0 ? void 0 : _e.newMetaSessionId
            : null;
        searchParams.append("meta_user_session_id", "".concat(feMus || (actionData === null || actionData === void 0 ? void 0 : actionData.meta_user_session_id)));
        searchParams.append("bookAllowed", "".concat(payloadData === null || payloadData === void 0 ? void 0 : payloadData.bookAllowed));
        searchParams.append("hasAccessToBooks", "".concat(payloadData === null || payloadData === void 0 ? void 0 : payloadData.hasAccessToBooks));
        searchParams.append("railName", "".concat(payloadData === null || payloadData === void 0 ? void 0 : payloadData.railName));
        searchParams.append("railRank", "".concat(payloadData === null || payloadData === void 0 ? void 0 : payloadData.railRank));
        searchParams.append("tileRank", "".concat(payloadData === null || payloadData === void 0 ? void 0 : payloadData.tileRank));
        searchParams.append("pageName", "".concat(payloadData === null || payloadData === void 0 ? void 0 : payloadData.pageName));
        searchParams.append("click_source", "".concat(payloadData === null || payloadData === void 0 ? void 0 : payloadData.click_source));
        searchParams.append("client_id", "".concat((payloadData === null || payloadData === void 0 ? void 0 : payloadData.client_id) || client_id));
        searchParams.append("date_tz", "".concat((payloadData === null || payloadData === void 0 ? void 0 : payloadData.date_tz) || Intl.DateTimeFormat().resolvedOptions().timeZone));
        try {
            path = "".concat(BASE_API_GATEWAY_URL, "/playable-service/digital_library/digital_library_playable?").concat(searchParams);
            options = {
                path: path,
                closeHandler: (_f = props.actionParams) === null || _f === void 0 ? void 0 : _f.closeHandler,
                playableName: 'Digital Library',
                multiplayer: true,
                redirectToPurchase: function () {
                    window.location.hash = "/purchase?source=".concat(BOOKLIBRARY, "&trigger=limitBreach");
                },
                setRandomPurchaseUUID: function (purchaseObj) {
                    var purchaseEventObject = {
                        expiryTimeSecs: 3600000,
                        populateTime: Date.now(),
                        data: purchaseObj,
                        key: "purchase_event_data",
                    };
                    var serializedData = JSON.stringify(purchaseEventObject);
                    // Save it to localStorage. Used 'flutter.' as it is fetched in flutter repo too
                    localStorage.setItem('flutter.purchase_event_data', JSON.stringify(serializedData));
                }
            };
            console.log("content type book launched from web-ui");
            //@ts-ignore
            window.SPWidget.launchContentGame(options);
        }
        catch (e) {
            sendErrorToSentry(e, { from: 'bookLauncher method' });
            console.error(e);
        }
        return [2 /*return*/];
    });
}); };
